import { zodResolver } from '@hookform/resolvers/zod'
import { AvailableLanguages } from '@repo/toolkit/language-types'
import { TFunction } from 'i18next'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import useTranslate from '../../../../lib/hooks/use-translate'
import { MobileNumberForFrenchLeaderInput } from '../../../../lib/types/models/ol/mobile-number-for-french-leader/mobile-number-for-french-leader-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { PHONE_NUMBER_SCHEMA } from '../../../../lib/utils/validations/phone-number.validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledPhoneInput from '../../../elements/inputs/controlled-phone-input'
import ValidationButtons from '../../../elements/validation-buttons'

type Props = BaseFormProps<MobileNumberForFrenchLeaderInput> & {
  className?: string
  defaultValues?: MobileNumberForFrenchLeaderInput
}

const formSchema: (
  t: TFunction<AvailableLanguages, undefined>
) => ZodType<MobileNumberForFrenchLeaderInput> = (t) =>
  z.object({
    phoneNumber: PHONE_NUMBER_SCHEMA(t)
  })

const MobileNumberForFrenchLeaderForm: React.FC<Props> = ({
  className,
  defaultValues,
  ...validationButtonProps
}) => {
  const { t } = useTranslate()
  const form = useForm<MobileNumberForFrenchLeaderInput>({
    resolver: zodResolver(formSchema(t)),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className="divide-y divide-white-active">
          <div className={className}>
            <FormField
              control={form.control}
              name={`phoneNumber`}
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormControl>
                    <ControlledPhoneInput
                      {...field}
                      required
                      label="Phone number"
                      defaultCountry="FR"
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
          <div className="pb-6 px-4">
            <ValidationButtons {...validationButtonProps} />
          </div>
        </div>
      </form>
    </Form>
  )
}

export default MobileNumberForFrenchLeaderForm
